import React from 'react'

const ElementsSkeleton = () => {
  return (
    <div>ElementsSkeleton</div>
  )
}

export default ElementsSkeleton